import React from "react";
import {Container, StarsContainer} from "./SignUpHeader.styles";

interface SignUpHeaderProps {
    title?: string,
    description?: string,
    error?: string}

const SignUpHeader = ({title, description, error}: SignUpHeaderProps) => {
    return <Container>
        <div>
            <div className="screenTitle">
                {title}
            </div>
            <div className="screenDescription">
                {description}
            </div>
            <div className="screenError">
                {error}
            </div>
        </div>
        <div><StarsContainer /> </div>
    </Container>
}

export default SignUpHeader;